export default __webpack_public_path__ + "static/media/Rectangles_03.fad31e69.png";